export default __webpack_public_path__ + "static/media/patient-on-bed-ns-demo.3e4dbaca.png";